import { AbstractControl, ValidatorFn } from '@angular/forms';

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isValid = !control.value || /^((?!\.)[\w-_.]*[^.])(@[a-z\d-]+)((\.[a-z\d-]+)?\.[a-z]{2,})$/i.test(control.value);
    return isValid ? null : { email: true };
  };
}
